import React from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";
import clsx from "clsx";
import useHelper from "../../components/_common/useHelper";

import { makeStyles, useTheme } from "@material-ui/styles";
import { Box, AppBar, Tabs, Tab } from "@material-ui/core";

const BORDERED_LAYOUT = process.env.REACT_APP_BORDERED_LAYOUT
    ? JSON.parse(process.env.REACT_APP_BORDERED_LAYOUT)
    : false;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            // aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "none",
        fontWeight: 500,
        lineHeight: 1.4,
        fontSize: "1rem",
        [theme.breakpoints.down("sm")]: {
            // fontSize: "0.5rem",
            display: "none",
        },
    },
    tabTitleMobile: {
        textTransform: "none",
        fontWeight: 600,
        lineHeight: 1.4,
        fontSize: "1.125rem",
        color: theme.palette.primary.main,
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    tabImg: {
        maxWidth: 72,
        [theme.breakpoints.down("sm")]: {
            maxWidth: 48,
        },
    },
    tabRoot: {
        alignItems: "baseline",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(4.5, 4.5, 0, 0) : 0,
        "&:focus-visible": {
            outline: "#000 auto 2px",
        },
    },
    tabRootActive: {
        border: BORDERED_LAYOUT ? "1px solid #00000033" : "none",
        borderBottomColor: BORDERED_LAYOUT ? "#FFF" : "inherit",
        backgroundColor: "#FFF",
    },

    tabPanelActive: {
        border: BORDERED_LAYOUT ? "1px solid #00000033" : "none",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(0, 0, 4.5, 4.5) : 0,
        marginTop: -1,
    },

    tabPanelText: {
        marginBottom: 30,
        fontSize: "1.25rem",
        padding: "24px 40px 0px 40px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
            padding: "16px 0px 0px 0px",
        },
        "& p": {
            margin: 0,
            marginBottom: 16,
        },
    },
    tabIndicator: {
        maxWidth: "17%",
        minWidth: "17%",
        marginLeft: "8.25%",
        "& span": {
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${theme.palette.primary.main}`,
            position: "absolute",
            top: 1,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    overflowVisible: {
        overflow: "visible!important",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(4.5, 4.5, 0, 0) : 0,
        backgroundColor: BORDERED_LAYOUT ? "#00000003" : "inherit",
    },
}));

const TabsFAQ = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    // const { i18n } = useTranslation();
    const { translationFromJson } = useHelper();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const faqs = [
        {
            id: "1",
            title: "Czym jest RSI?",
            title_en: "What is Information Systems Repository?",
            text: `<p tabindex='0'>Repozytorium Systemów Informacyjnych (w skrócie RSI) jest bazą wiedzy obejmującą metadane o rejestrach urzędowych i systemach informacyjnych administracji publicznej aktualizowaną przez gestorów oraz administratora RSI o wybrane rejestry/systemy za pomocą aplikacji internetowej Głównego Urzędu Statystycznego.</p>`,
            text_en: `<p tabindex='0'>Information Systems Repository (RSI) is a knowledge base comprising metadata about official registers and public administration information systems updated by data owners and the RSI administrator with selected registers/systems using the Statistics Poland web application.</p>`,
            icon: "/icons/home/czym.png",
        },
        // {
        //     id: "2",
        //     title: "Jak w RSI zdefiniowano standard informacyjny?",
        //     title_en: "How is the information standard defined in the RSI",
        //     text: "<p tabindex='0'>Standard informacyjny to norma wprowadzona w drodze porozumienia przez grupę jednostek administracji publicznej, stanowiąca zobowiązanie do stosowania w prowadzonych systemach informacyjnych ustalonych Systemów np.: identyfikatorów, klasyfikacji.</p>",
        //     text_en:
        //         "<p tabindex='0'>An information standard is a standard implemented by agreement by a group of public administration entities. It means a commitment for them to use established standards in the information systems they maintain, e.g.: identifiers, classifications.</p>",
        //     icon: "/icons/home/jak.png",
        // },
        {
            id: "3",
            title: "Jakie systemy opisuje RSI?",
            title_en: "What systems does RSI describe?",
            text: `<p tabindex='0'>Repozytorium Systemów Informacyjnych opisuje: 
            <ul>
            <li>rejestry urzędowe - rejestry publiczne w rozumieniu ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne oraz inne rejestry i ewidencje prowadzone na podstawie ustaw lub wydanych na ich podstawie aktów wykonawczych, zawierające informacje o podmiotach gospodarki narodowej i ich działalności, informacje o osobach fizycznych, ich życiu i sytuacji oraz dotyczące zjawisk, zdarzeń i obiektów;</li>
            <li>systemy informacyjne administracji publicznej - systemy zbierania, gromadzenia i przetwarzania informacji przez organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisję Nadzoru Finansowego, organy rejestrowe, inne państwowe lub samorządowe osoby prawne oraz inne podmioty prowadzące rejestry urzędowe.</li>
            </ul>
            </p>`,
            text_en: `<p tabindex='0'>
                <ul>
                <li>official registers - public registers within the meaning of the Act of 17 February 2005 on the computerisation of activities of entities performing public tasks, and other registers and records kept on the basis of acts of law or executive acts issued on the basis thereof, containing information on the entities of the national economy, and their activity, on natural persons, their lives and situation, as well as on phenomena, events and objects;</li>
                <li>public administration information systems - systems for collecting, gathering and processing information by public administration authorities, Social Insurance Institution, National Health Fund, Polish Financial Supervision Authority, registration authorities, other state or local government legal persons and other entities keeping official registers.</li>
                </ul>
                </p>`,
            icon: "/icons/home/jakie.png",
        },
        {
            id: "4",
            title: "Dlaczego zbudowano RSI?",
            title_en: "Why was the RSI built?",
            text: "<p tabindex='0'>Dzięki rozwijaniu się technologii informacyjnych i komunikacyjnych powstają nowe  zasoby danych. Administracja publiczna buduje nowe systemy informacyjne i tworzy nowe standardy informacyjne.</p><p>Wprowadzanie w statystyce publicznej nowych źródeł danych spowodowało konieczność opracowania systemu do zarządzania metadanymi.</p><p>Informacje zgromadzone w RSI stanowią podstawę do oceny jakości i badania spójności systemów informacyjnych administracji publicznej z punktu widzenia użyteczności dla statystyki publicznej jako źródeł danych.</p><p>Zgromadzony w RSI zasób informacyjny ma charakter referencyjny i będzie mógł być przedmiotem analiz oraz stanowić podstawę do podejmowania decyzji o wykorzystaniu zasobów informacyjnych rejestrów urzędowych i systemów informacyjnych administracji publicznej prowadzonych przez inne instytucje oraz do modernizacji własnych rejestrów i systemów.</p><p>Zgromadzone opisy tworzą bazę wiedzy o rejestrach administracyjnych i systemach informacyjnych administracji publicznej, której jednym z głównych zadań jest wspieranie zapewnienia interoperacyjności systemów poprzez:<ul><li>stworzenie warunków do podniesienia jakości dziedzinowych systemów informacyjnych, w tym zwiększenia zgodności metodologicznej,</li><li>stworzenie warunków do zwiększenia efektywności dziedzinowych systemów informacyjnych w ramach poszczególnych działów, jak i systemu informacyjnego państwa, jako całości,</li><li>uzyskanie współdziałania systemów informacyjnych oraz ich interoperacyjności,</li><li>zwiększenie efektywności finansowej projektów realizowanych ze środków publicznych, w tym w ramach programów operacyjnych UE.</li></ul></p><p>Wykorzystanie RSI będzie miało pozytywny wpływ także na obniżenie obciążeń administracyjnych osób i podmiotów związanych z wielokrotnym dostarczaniem tych samych informacji do różnych jednostek administracji, w tym statystyki publicznej.</p><p>W efekcie ww. prac ułatwione będzie wyłonienie systemów referencyjnych, tj. takich, które gromadzą informacje pierwotnie, stanowią normy informacyjne, zapewniają aktualizację innym systemom administracji publicznej.</p>",
            text_en: `<p tabindex='0'>Thanks to the development of information and communication technologies, new data resources are being created. Public administration is builds new information systems and creates new information standards.</p>
            <p>The implementation of new data sources in official statistics caused the development of a system for metadata management.</p>
            <p>The information collected in the RSI provides a basis for assessing the quality and testing the consistency of public administration information systems from the point of view of usability for the official statistics as data sources.</p>
            <p>The information resource collected in the RSI is of a reference nature and will be able to be analyzed and form the basis for decisions on the use of information resources of official registers and public administration information systems maintained by other institutions, as well as for the modernization of own registers and systems.</p>
            <p>The collected descriptions form (RSI). One of the main tasks of RSI is to support the provision of system interoperability by:
            <ul>
            <li>creating conditions for increasing the quality of domain information systems, including increasing methodological compatibility,</li>
            <li>creating conditions for increasing the efficiency of domain information systems within individual domains, as well as the state information system as a whole,</li>
            <li>achieving interaction between information systems and their interoperability,</li>
            <li>increasing the financial efficiency of projects implemented with public funds, including the projects implemented under EU operational programs.</li>
            </ul></p>
            <p>The use of RSI will also have a positive impact on reducing the administrative burden on individuals and entities associated with the repeated provision of the same information to different administrative units, including public statistics.</p>
            <p>As a result of the aforementioned work, it will be easier to identify reference systems, i.e. those that collect information as a primary data source, constitute information standards, provide updates to other public administration systems.</p>`,
            icon: "/icons/home/dlaczego.png",
        },
    ];

    return (
        <div className={classes.root}>
            <AppBar position="static" color="transparent" elevation={0}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    classes={{
                        indicator: classes.tabIndicator,
                        root: classes.overflowVisible,
                        fixed: classes.overflowVisible,
                    }}
                    TabIndicatorProps={{ id: "f-l-i", dangerouslySetInnerHTML: { __html: "<span/>" } }}
                >
                    {faqs.map((faq, i) => {
                        return (
                            <Tab
                                key={i}
                                label={
                                    <React.Fragment>
                                        <img className={classes.tabImg} src={faq.icon} alt="" />
                                        <span
                                            className={classes.tabTitle}
                                            dangerouslySetInnerHTML={{ __html: translationFromJson(faq, "title") }}
                                        />
                                    </React.Fragment>
                                }
                                classes={{ root: clsx(classes.tabRoot, i === value && classes.tabRootActive) }}
                                disableRipple
                                {...a11yProps(i)}
                            />
                        );
                    })}
                </Tabs>
            </AppBar>
            {faqs.map((faq, i) => {
                return (
                    <TabPanel
                        value={value}
                        index={i}
                        dir={theme.direction}
                        key={i}
                        className={clsx(i === value && classes.tabPanelActive)}
                    >
                        <span
                            className={classes.tabTitleMobile}
                            dangerouslySetInnerHTML={{ __html: translationFromJson(faq, "title") }}
                        />
                        <div
                            dangerouslySetInnerHTML={{ __html: translationFromJson(faq, "text") }}
                            className={classes.tabPanelText}
                            // tabIndex={0}
                        />
                    </TabPanel>
                );
            })}
        </div>
    );
};

export default TabsFAQ;
